import request, { _POST } from "@/services/request";

// 接口路径抽成常量，方便后端同学改路径时统一替换
const BASE = "/api/compliance/wordbook";

export type ComplianceRiskLevel = "high" | "medium" | "low";

// 合规词表分类
export type ComplianceCategory = {
  id: string;
  name: string;
  // 风险等级：high 直接拦截 / medium 需复审 / low 仅提醒
  riskLevel: ComplianceRiskLevel;
  // issue 类型标识，后端自动生成（用分类 id），前端无需填写
  issueType: string;
  // 命中后的提示文案，后端自动生成（"命中{分类名称}"），前端无需填写
  reason: string;
  // 是否启用
  enabled: boolean;
  // 词条列表
  words: string[];
};

// agent 拉取合规词表的响应
export type ComplianceWordbookRsp = {
  categories: ComplianceCategory[];
  updatedAt?: string;
};

export type ComplianceCategoryListReq = {
  keyword?: string;
  riskLevel?: ComplianceRiskLevel;
  enabled?: boolean;
};

export type ComplianceCategoryListRsp = {
  list: ComplianceCategory[];
  total: number;
};

// 创建分类：issueType 和 reason 由后端自动生成，前端不传
export type ComplianceCategoryCreateReq = {
  name: string;
  riskLevel: ComplianceRiskLevel;
  enabled: boolean;
  words: string[];
};

export type ComplianceCategoryUpdateReq = {
  id: string;
  name?: string;
  riskLevel?: ComplianceRiskLevel;
  enabled?: boolean;
  words?: string[];
};

export type ComplianceCategoryDeleteReq = { id: string };

/** 拉取完整词库（agent 调用，返回所有启用的分类） */
const getComplianceWordbook = () => {
  return request<ComplianceWordbookRsp, undefined>(_POST, `${BASE}/get`)(undefined);
};

/** 分类列表（管理界面用，支持筛选） */
const listComplianceCategory = (params?: ComplianceCategoryListReq) => {
  return request<ComplianceCategoryListRsp, ComplianceCategoryListReq>(_POST, `${BASE}/list`)(params ?? {});
};

/** 创建分类 */
const createComplianceCategory = (params: ComplianceCategoryCreateReq) => {
  return request<ComplianceCategory, ComplianceCategoryCreateReq>(_POST, `${BASE}/create`)(params);
};

/** 更新分类 */
const updateComplianceCategory = (params: ComplianceCategoryUpdateReq) => {
  return request<ComplianceCategory, ComplianceCategoryUpdateReq>(_POST, `${BASE}/update`)(params);
};

/** 删除分类 */
const deleteComplianceCategory = (params: ComplianceCategoryDeleteReq) => {
  return request<null, ComplianceCategoryDeleteReq>(_POST, `${BASE}/delete`)(params);
};

const complianceWordbookApis = {
  getComplianceWordbook,
  listComplianceCategory,
  createComplianceCategory,
  updateComplianceCategory,
  deleteComplianceCategory,
};

export default complianceWordbookApis;
